import { Card, CardContent, styled } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid var(--mui-palette-divider, #2B3674)',
  borderRadius: 0,
  boxShadow: 'none',
  textAlign: 'center',
  transition: 'border-color 160ms ease, transform 160ms ease',
  [theme.breakpoints.up('xl')]: {
    minWidth: '280px',
  },
}));

export const Inner = styled(CardContent, {
  shouldForwardProp: (prop) => prop !== 'gridColumns' && prop !== 'gridRows',
})<{ gridColumns: number; gridRows: number }>(({ gridColumns, gridRows }) => ({
  display: 'grid',
  flex: 1,
  gap: '14px',
  gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`,
  gridTemplateRows: `repeat(${gridRows}, minmax(80px, auto))`,
  position: 'relative',
  width: '100%',
}));

export const FieldWrapper = styled('div')(() => ({
  width: '100%',
  minHeight: '80px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
